import { useEffect, useState } from "react";
import { handleProductNavigation } from "../utils/menuUtils";

export function useMenuEffects({
    categories,
    selectedCategory,
    setSelectedCategory,
    isLoadingProducts,
    preselectedCategoryId,
    categoryScrollRef,
    triggerRef,
    setHasActiveCategory,
    hasSeenModal,
    weeklyNewProduct,
    openModal,
    navigate
}) {
    const [showScrollTop, setShowScrollTop] = useState(false);
    const [isSticky, setIsSticky] = useState(false);
    const [isLoadingCategories, setIsLoadingCategories] = useState(!categories?.length);

    useEffect(() => {
        if (categories?.length > 0) {
            if (preselectedCategoryId) {
                const found = categories.find((cat) => cat.id === preselectedCategoryId);
                if (found) {
                    setSelectedCategory(found.id);
                    setHasActiveCategory(true);
                    return;
                }
            }
            const savedCategory = sessionStorage.getItem("activeCategory");
            if (savedCategory && categories.some(cat => cat.id === savedCategory)) {
                setSelectedCategory(savedCategory);
                setHasActiveCategory(true);
            } else if (!preselectedCategoryId && !sessionStorage.getItem("scrollPosition")) {
                setSelectedCategory(null);
                setHasActiveCategory(false);
            }
        }
    }, [categories, preselectedCategoryId, setSelectedCategory, setHasActiveCategory]);

    useEffect(() => {
        const handleScroll = () => {
            const scrollY = window.scrollY;
            setShowScrollTop((prev) => (scrollY > 320 ? true : scrollY < 280 ? false : prev));
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    useEffect(() => {
        if (categories?.length > 0) {
            const timer = setTimeout(() => setIsLoadingCategories(false), 800);
            return () => clearTimeout(timer);
        }
    }, [categories]);

    useEffect(() => {
        if (!isLoadingCategories && !isLoadingProducts && selectedCategory && !preselectedCategoryId) {
            const savedScroll = sessionStorage.getItem("scrollPosition");

            if (savedScroll) {
                const rafid = requestAnimationFrame(() => {
                    window.scrollTo(0, parseInt(savedScroll, 10));
                    sessionStorage.removeItem("scrollPosition");
                    // Abbiamo rimosso il ripristino forzato di categoryScrollRef.current.scrollLeft qui dentro
                });
                return () => cancelAnimationFrame(rafid);
            }
        }
    }, [isLoadingCategories, isLoadingProducts, preselectedCategoryId, selectedCategory]);

    useEffect(() => {
        const observer = new IntersectionObserver(([e]) => setIsSticky(!e.isIntersecting), { threshold: 0 });
        if (triggerRef.current && selectedCategory) observer.observe(triggerRef.current);
        return () => observer.disconnect();
    }, [selectedCategory, triggerRef]);

    useEffect(() => {
        if (selectedCategory && categories?.length > 0 && weeklyNewProduct) {
            // Questa è la chiave unica basata sul prodotto della settimana
            const currentTrackingKey = `weeklyNew_${weeklyNewProduct.id}`;

            // Controlliamo se abbiamo visto QUESTO specifico prodotto
            if (!hasSeenModal(currentTrackingKey)) {
                const timer = setTimeout(() => {
                    openModal("weeklyNew", { // Il nome della modale resta pulito per la grafica
                        trackingKey: currentTrackingKey, // 🌟 Passiamo la chiave dinamica qui
                        product: weeklyNewProduct,
                        onViewDetail: (prod) => handleProductNavigation(prod, [prod], 0, navigate)
                    });
                }, 500);
                return () => clearTimeout(timer);
            }
        }
    }, [selectedCategory, categories, weeklyNewProduct, hasSeenModal, openModal, navigate]);

    return { showScrollTop, isSticky, isLoadingCategories };
}